import * as React from 'react';
import { TextInput, ITextInputProps } from 'ui-toolkit';
import { useState } from 'react';
import { ReactNode } from 'react';

interface ITextInputLimitValue extends ITextInputProps {
  regExp?: RegExp | string;
  limitInputHintText?: ReactNode;
}

export const TextInputLimitValue: React.FC<ITextInputLimitValue> = ({
  onChange,
  hintText,
  regExp,
  limitInputHintText,
  ...rest
}) => {
  const [inputWasUpdated, setInputWasUpdated] = useState(false);
  const onLimitChange = (newValue: string | null) => {
    const cleanValue = newValue ? newValue.replace(regExp ? regExp : /[^a-zA-Z0-9,/_\- ]/g, '') : null;
    onChange && onChange(cleanValue);
    if (newValue) {
      if (newValue !== cleanValue) setInputWasUpdated(true);
    } else {
      setInputWasUpdated(false);
    }
  };

  return (
    <TextInput
      {...rest}
      onChange={onLimitChange}
      hintText={
        hintText || inputWasUpdated ? (
          <>
            {hintText ? hintText : null}
            {inputWasUpdated ? (
              <div>{limitInputHintText ? limitInputHintText : 'Invalid characters have been removed'}</div>
            ) : null}
          </>
        ) : undefined
      }
    />
  );
};
